"use client";
import axios from "../../../utils/axios";
import { Button, CheckboxInput, useConfirmDelete } from "djinn-components";
import React, { useEffect, useState } from "react";
import { ContentPageEditProps } from "..";
import { toast } from "react-toastify";
import { useSiteState } from "../../../utils/useSiteState";
import { useNavigate } from "react-router-dom";

const PageSettingsTab: React.FC<ContentPageEditProps> = ({ reload, page }) => {
  const { site, reload: reloadSite } = useSiteState();
  const navigate = useNavigate();
  const deletePage = useConfirmDelete();
  const [apiLoading, setApiLoading] = useState(false);

  const [published, setPublished] = useState(page.published);

  const deletePageCallback = async () => {
    setApiLoading(true);
    try {
      await axios.delete(`sites/${site.id}/pages/${page.id}`);
      await reloadSite();
      navigate(`/${site.id}/pages`);
      toast("Page successfully deleted!", { type: "success" });
    } catch (error) {
      toast("Failed to delete page!", { type: "error" });
    }
    setApiLoading(false);
  };

  const updatePagePublishedStatus = async () => {
    try {
      await axios.put(`sites/${site.id}/pages/${page.id}`, {
        published,
      });
      toast("Page status updated", { type: "success" });
    } catch (error) {
      toast("Failed to update page status", { type: "error" });
    }
    await reload();
  };

  useEffect(() => {
    if (published !== page.published) {
      updatePagePublishedStatus();
    }
  }, [published]); // eslint-disable-line

  return (
    <div className="w-full py-10">
      <label className="py-4 mx-auto w-3/4 bg-gray-250 p-6 rounded-lg mt-8 flex items-center justify-between">
        <div className="py-3">
          <p className="text-md text-white">Published</p>
          <p className="text-sm text-gray-400">
            Page will be publicly available on your site
          </p>
        </div>

        <CheckboxInput
          id="published"
          value={published}
          onChange={(v) => setPublished(!published)}
        />
      </label>
      <div className="py-4 mx-auto w-3/4 bg-gray-250 p-6 rounded-lg mt-8">
        <div className="col-span-6 mb-4 flex items-center justify-between">
          <div>
            <p className="mt-2 text-md text-white">Delete Page</p>
            <p className="text-sm text-gray-400">
              This action is not reversible so be sure you want to do it.
            </p>
          </div>
          <span className="w-32 mt-2 pt-1">
            <Button
              text="Delete"
              type="button"
              onClick={() => deletePage("DELETE PAGE", deletePageCallback)}
              buttonStyle="red"
              disabled={apiLoading}
              loading={apiLoading}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default PageSettingsTab;
